import Vue from 'vue';
import router from '@/router/index.js';
import VueAnalytics from 'vue-analytics';

const isProd = window.location.host.includes('preventiablue.z19.web.core.windows.net');
const prodAllTrackingId = 'UA-164972187-2';
const devAllTrackingId = 'UA-164972187-1';

export default {
  // todo: use a tracking id passed in from the user org data
  setup: function () {
    Vue.use(VueAnalytics, {
      id: function () {
        if (isProd) {
          return prodAllTrackingId;
        } else {
          // default to dev for localhost and as a catch-all
          return devAllTrackingId;
        }
      },
      router,
      autoTracking: {
        exception: true,
        pageviewTemplate: (route) => {
          let location = window.location.href.replace(route.params.id, 'id');
          let page = route.path.replace(route.params.id, 'id');
          location = window.location.href.replace(route.params.clientId, 'clientId');
          page = route.path.replace(route.params.clientId, 'clientId');
          return {
            title: document.title,
            location: location,
            page: page
          };
        }
      }
    });
  }
};
